import { useContext, useEffect, useState } from "react";
import { UserContext } from "contexts/";

export default function useMembershipStatus() {
	const { membershipStatusRef } = useContext(UserContext);

	const [membershipStatus, setMembershipStatus] = useState({});

	useEffect(() => {
		setMembershipStatus(membershipStatusRef.current || {});
	}, [membershipStatusRef.current]);
	return membershipStatus || {};
}
